import * as React from 'react';
import useFooter from '../../hooks/useFooter';
import isExternalUrl, {
  addTrailingSlash,
  isExternalUrlhref,
} from '../../utils';
import * as Styled from './footerStyles';

const Footer = () => {
  const footerData = useFooter();
  return (
    <React.Fragment>
      <Styled.FooterContainer>
        <Styled.Footer>
          <Styled.FooterLeft>
            <Styled.ImageStyle
              src={footerData?.imageWithPath?.image?.file?.url}
              alt={footerData?.imageWithPath?.image?.file?.fileName}
            />
          </Styled.FooterLeft>
          <Styled.FootRight>
            <Styled.AnchorStyle
              href={
                isExternalUrlhref(footerData?.TextWithPaths[0]?.path)
                  ? footerData?.TextWithPaths[0]?.path
                  : addTrailingSlash(
                      process.env.GATSBY_DOMAIN_URL +
                        footerData?.TextWithPaths[0]?.path
                    )
              }
              target={
                isExternalUrl(footerData?.TextWithPaths[0]?.path)
                  ? '_blank'
                  : '_self'
              }
            >
              {footerData?.TextWithPaths[0]?.text}
            </Styled.AnchorStyle>
            <Styled.AnchorStyle
              href={
                isExternalUrlhref(footerData?.TextWithPaths[1]?.path)
                  ? footerData?.TextWithPaths[1]?.path
                  : addTrailingSlash(
                      process.env.GATSBY_DOMAIN_URL +
                        footerData?.TextWithPaths[1]?.path
                    )
              }
              target={
                isExternalUrl(footerData?.TextWithPaths[1]?.path)
                  ? '_blank'
                  : '_self'
              }
            >
              {footerData?.TextWithPaths[1]?.text}
            </Styled.AnchorStyle>
            <Styled.AnchorStyle
              href={
                isExternalUrlhref(footerData?.TextWithPaths[2]?.path)
                  ? footerData?.TextWithPaths[2]?.path
                  : addTrailingSlash(
                      process.env.GATSBY_DOMAIN_URL +
                        footerData?.TextWithPaths[2]?.path
                    )
              }
              target={
                isExternalUrl(footerData?.TextWithPaths[2]?.path)
                  ? '_blank'
                  : '_self'
              }
            >
              {footerData?.TextWithPaths[2]?.text}
            </Styled.AnchorStyle>
          </Styled.FootRight>
          <div style={{ clear: 'both' }} />
        </Styled.Footer>
      </Styled.FooterContainer>
      <div style={{ clear: 'both' }} />
    </React.Fragment>
  );
};

export default Footer;
